// extracted by mini-css-extract-plugin
export default {"wrapper":"nT-z","availablePromoMessagesLabel":"oT-z","promoMessageList":"pT-z","promoMessage":"qT-z","appliedPromoMessage":"rT-z","promoMessageAmount":"sT-z"};